import { Inject, Injectable } from '@angular/core';
import { IDGSEnvironment } from '../models/environment';
import { IAppConfig } from '../models/app-config';
import { Helper } from '../shared';

@Injectable({
  providedIn: 'platform',
})
export class AppConfigService {
  static settings: IAppConfig = {} as IAppConfig;

  constructor(
    @Inject('environment') private environment: IDGSEnvironment,
  ) { }
  
  public load() {
    const jsonFile = this.environment.settingsUrl;
    return new Promise<void>((resolve, reject) => {
      fetch(jsonFile)
        .then(response => response.json())
        .then((data) => {
          AppConfigService.settings = data as IAppConfig;

          if(!Helper.isValidUrl(AppConfigService.settings.apiUrl)) {
            this.setEnvironmentAPIURI();
          };

          resolve();
        })
        .catch((response: any) => {
          reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
        });
    });
  }

  private setEnvironmentAPIURI(){
    AppConfigService.settings['apiUrl'] = this.environment.apiUrl;
  }
}
